import { useQuery } from '@tanstack/react-query'

import { getBuilderVideos } from '../services/builder-videos/get-builder-videos.service'

import { CardActivityType } from '@/models/card-activity/card-activity.model'

export const builderVideosQueryKeys = {
  all: ['builder-videos'] as const,
}

const ORDER_VIDEOS = [
  CardActivityType.READ_REPEAT,
  CardActivityType.READ_RESPOND,
  CardActivityType.RESPOND_WRITE,
  CardActivityType.MULTIPLE_CHOICE,
  CardActivityType.MEDIA_PAGE,
  'bulk_creator',
]

export function useBuilderVideos() {
  const query = useQuery({
    queryKey: builderVideosQueryKeys.all,
    queryFn: getBuilderVideos,
  })

  const getVideoId = (url: string) => {
    const videoId = url.split('/share/')[1].split('?')[0]

    return videoId
  }

  const generateVideoUrl = (url: string) => {
    const videoId = getVideoId(url)

    return `https://www.loom.com/embed/${videoId}`
  }

  return {
    ...query,
    builderVideos: query.data?.sort((a, b) => ORDER_VIDEOS.indexOf(a.type) - ORDER_VIDEOS.indexOf(b.type)),
    isLoading: query.isPending,
    getVideoId,
    generateVideoUrl,
  }
}
